import _indexOf from './_indexOf';

export default function _contains(a, list) {
  return _indexOf(list, a, 0) >= 0;
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/internal/_contains.js
// module id = 152
// module chunks = 1